/* eslint-disable no-unused-vars */
import React from 'react';
import { FilledInput, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import useTailwindBrand from '../../Theme/useTailwindBrand';

interface FormInputProps {
  label: string;
  type?: string;
  placeholder?: string;
  value?: string | number | React.ReactNode;
  error?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Utilisé quand textarea est true */
  onChangeText?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  name?: string;
  showPasswordToggle?: boolean;
  onTogglePassword?: () => void;
  showPassword?: boolean;
  required?: boolean;
  autoComplete?: string;
  className?: string;
  disabled?: boolean;
  textarea?: boolean;
  readOnly?: boolean;
  isEditing?: boolean;
  endAdornment?: React.ReactNode;
  onClick?: () => void;
}

const FormInput = React.forwardRef<HTMLInputElement, FormInputProps>(({
  label,
  type,
  placeholder = '',
  value,
  error,
  onChange,
  onChangeText,
  name,
  showPasswordToggle = false,
  onTogglePassword,
  showPassword = false,
  required = false,
  autoComplete,
  disabled = false,
  textarea = false,
  className,
  readOnly,
  isEditing,
  endAdornment,
  onClick,
}, ref) => {
  const { classes, brandConfig } = useTailwindBrand();
  const hasEndAdornment = !!endAdornment || (showPasswordToggle && !!onTogglePassword);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <div className=''>

      <FormControl variant="filled" fullWidth>
        <InputLabel
          required={required}
          className={`${classes.fontFamily} ${error ? classes.error : classes.text} font-semibold [&_.MuiFormLabel-asterisk]:text-red-400 ${label ? `` : `hidden`}`}
          // réserve la place de l'icône (œil, adornment) pour éviter que le
          // libellé non rétréci passe dessous
          sx={hasEndAdornment ? { '&:not(.MuiInputLabel-shrink)': { maxWidth: 'calc(100% - 64px)' } } : undefined}
        >{label}</InputLabel>
        {
          !textarea ? (
            <FilledInput
              // onPaste={(e) => {
              //   if (type === 'password') {
              //     e.preventDefault();
              //   }
              // }}
              type={type}
              name={name}
              placeholder={placeholder}
              value={value ?? ''}
              onChange={onChange}
              onClick={onClick}
              autoComplete={autoComplete}
              disabled={disabled}
              readOnly={readOnly}
              error={!!error}
              inputRef={ref}
              className={`${classes.fontFamily} ${error ? classes.errorBorder + ' border-l-4' : isEditing ? classes.primaryBorder : 'border-gray-400'} bg-white rounded-md border ${className}`}
              sx={{
                transition: 'border-color .2s ease, box-shadow .2s ease',
                '&.Mui-focused': {
                  borderColor: brandConfig.colors.primary,
                  boxShadow: `0 0 0 3px ${brandConfig.colors.primary}1f`,
                },
              }}
              endAdornment={
                endAdornment ? endAdornment :
                showPasswordToggle && onTogglePassword && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={showPassword ? 'hide the password' : 'display the password'}
                    onClick={onTogglePassword}
                    onMouseDown={handleMouseDownPassword}
                    onMouseUp={handleMouseUpPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )}
            />
          ) : (
            <FilledInput
              multiline
              minRows={4}
              name={name}
              placeholder={placeholder}
              value={value ?? ''}
              onChange={onChangeText}
              disabled={disabled}
              readOnly={readOnly}
              error={!!error}
              className={`${classes.fontFamily} ${error ? classes.errorBorder + ' border-l-4' : isEditing ? classes.primaryBorder : 'border-gray-400'} bg-white rounded-md border `}
              sx={{
                transition: 'border-color .2s ease, box-shadow .2s ease',
                '&.Mui-focused': {
                  borderColor: brandConfig.colors.primary,
                  boxShadow: `0 0 0 3px ${brandConfig.colors.primary}1f`,
                },
              }}
            />
          )
        }

      </FormControl>
      {error && (
        <FormHelperText className={`${classes.fontFamily} ${classes.error} italic font-semibold`}>{error}</FormHelperText>
      )}
    </div>
  );
});

export default FormInput;

